module.exports = __webpack_public_path__ + "img/black_rook.019b2432.png";